import React from 'react';
import { useDynamicFavicon } from './hooks/useDynamicFavicon';

// Wrapper component to handle dynamic favicon changes
const FaviconWrapper = ({ children }) => {
  useDynamicFavicon();
  return <>{children}</>;
};

export default FaviconWrapper;
